import FileUpload from 'emerald-ui/lib/FileUpload';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: FileUpload, componentName: 'FileUpload' }], 'FileUpload'),
  description:
    'Receives a URL and does the uploading process, reporting progress and speed, and handling the abortion of the uploads.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FileUpload },
      code: `class DefaultFileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: props.files || []
    };

    this.handleUploadStart = this.handleUploadStart.bind(this);
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
    this.handleUploadError = this.handleUploadError.bind(this);
    this.handleProgress = this.handleProgress.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleUploadStart = files => {}
  handleUploadStart(files) {
    const messages = {
      size: 'File is too large. Please choose another file',
      format: 'File type not supported. We only support PNGs',
      single: 'Only one file upload is supported'
    };

    const filesWithRejectedMessages = files.map(file => {
      if (file.rejected) {
        file.message = messages[file.rejected];
      }

      return file;
    });

    this.setState(prevState => {
      const newFiles = [...prevState.files, ...filesWithRejectedMessages];

      return { files: newFiles };
    });
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleUploadSuccess = (result, id) => {}
  handleUploadSuccess(result, id, file) {
    console.log('This is the actual File object', file);

    this.setState(prevState => {
      const newFiles = prevState.files.map(prevFile => {
        if (prevFile.id === id) {
          prevFile.message = 'Done';
        }

        return prevFile;
      });

      return { files: newFiles };
    });
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleUploadError = (error, id) => {}
  handleUploadError(error, id, file) {
    console.log('This is the actual File object', file);

    this.setState(prevState => {
      const newFiles = prevState.files.map(prevFile => {
        if (prevFile.id === id) {
          prevFile.error = true;
          prevFile.message = 'This is a custom error message';
        }

        return prevFile;
      });

      return { files: newFiles };
    });
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleProgress = file => {}
  handleProgress(file) {
    this.setState(prevState => {
      const newFiles = prevState.files.map(prevFile => {
        if (prevFile.id === file.id) {
          prevFile.progress = file.progress;
          prevFile.speed = file.speed;
        }

        return prevFile;
      });

      return { files: newFiles };
    });
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleCancel = (fileName, id, aborted) => {}
  handleCancel(fileName, id, aborted) {
    if (!aborted) {
      // File finished uploading
      // Here goes the code to remove the file from the server
      console.log('This will be removed from the server');
    }

    // Removes the aborted file from the state
    this.setState(prevState => {
      const newFiles = [];

      prevState.files.forEach(prevFile => {
        if (prevFile.id !== id) {
          newFiles.push(prevFile);
        }
      });

      return { files: newFiles };
    });
  }

  render() {
    const {
      children,
      ...rest
    } = this.props;

    delete rest.files;

    return (
      <FileUpload
        {...rest}
        files={this.state.files}
        onCancel={this.handleCancel}
        onProgress={this.handleProgress}
        onUploadError={this.handleUploadError}
        onUploadStart={this.handleUploadStart}
        onUploadSuccess={this.handleUploadSuccess}
      >
        {children}
      </FileUpload>
    );
  }
}`,
    },
  ],
};
